import * as React from 'react';
export var useUndergroundActions = function useUndergroundActions(_ref) {
  var stations = _ref.stations,
      onSelect = _ref.onSelect,
      onRemove = _ref.onRemove,
      apiRef = _ref.apiRef,
      groups = _ref.groups;
  var handleSelect = React.useCallback(function (ids) {
    var stationsToAddIds = ids;
    /**
     * Если переданы группы станций выбираем всю группу, если была выбрана
     * хотя бы одна станция из группы
     */

    if (groups) {
      stationsToAddIds = stationsToAddIds.reduce(function (stationsWithGroups, stationId) {
        return stationsWithGroups.concat(groups.find(function (group) {
          return group.includes(stationId);
        }) || [stationId]);
      }, []);
    }

    var stationsToAdd = stationsToAddIds.map(function (id) {
      return stations.get(id);
    }).filter(nonEmptyStation);
    onSelect(stationsToAdd);
  }, [stations, onSelect, groups]);
  var handleRemove = React.useCallback(function (ids) {
    var stationToRemoveIds = ids;

    if (groups) {
      stationToRemoveIds = stationToRemoveIds.reduce(function (stationsWithGroups, stationId) {
        return stationsWithGroups.concat(groups.find(function (group) {
          return group.includes(stationId);
        }) || [stationId]);
      }, []);
    }

    var stationsToRemove = stationToRemoveIds.map(function (id) {
      return stations.get(id);
    }).filter(nonEmptyStation);
    onRemove(stationsToRemove);
  }, [stations, onRemove, groups]);
  React.useImperativeHandle(apiRef, function () {
    return {
      onSelect: handleSelect,
      onRemove: handleRemove
    };
  }, [handleRemove, handleSelect]);
  return React.useMemo(function () {
    return {
      handleSelect: handleSelect,
      handleRemove: handleRemove
    };
  }, [handleRemove, handleSelect]);
};

function nonEmptyStation(station) {
  return Boolean(station);
}